import {Fragment, useState} from "react";
import {useDispatch} from "react-redux";
import {Box} from "@mui/system";
import _ from "lodash";
import {screenshotActions, utilityActions} from "_actions";
import useViewMessageDetails from "../../../../Utilities/hooks/useViewMessageDetails";
import ConstructiveFeedbackEditor from "./ConstructiveFeedbackEditor";
import ConstructiveFeedbackFilterSelect from "./ConstructiveFeedbackFilterSelect";
import {buildConstructiveFeedbackPayload} from "../FeedbackUtils";
import {SnackBar} from "../../../../../../../../common";
import ActionButton from "../../../../../../../common/ActionButton";

export default function ConstructiveFeedbackContent({handleClose}) {
    const [text, setText] = useState('');
    const [selectedFeedbackType, setSelectedFeedbackType] = useState({});

    const dispatch = useDispatch();
    const {message} = useViewMessageDetails();

    const handleTextChange = (editorText) => {
        setText(editorText);
    }

    const handleFeedbackTypeSelection = (value) => {
        setSelectedFeedbackType(value)
    }

    const handleSubmit = () => {
        if(_.isEmpty(_.get(message, 'agent'))) {
            SnackBar.showMessage("No expert found");
            return;
        }
        if(_.isEmpty(selectedFeedbackType)) {
            SnackBar.showMessage("Select a feedback type");
            return;
        }
        const currentPath = utilityActions.getCurrentPath();
        const currPath = currentPath ? currentPath : "/screenshots";
        const payload = buildConstructiveFeedbackPayload(message, text, selectedFeedbackType);
        if(!payload) {
            return;
        }
        dispatch(screenshotActions.addScreenshot(payload, currPath));
        handleClose();
    }

    return(
        <Fragment>
            <Box sx={{mb: '20px'}}>
                <ConstructiveFeedbackFilterSelect
                    message={message}
                    onChange={handleFeedbackTypeSelection}
                />
            </Box>

            <ConstructiveFeedbackEditor
                isEmail={true}
                handleTextChange={handleTextChange}
            />
            <Box sx={style.buttonContainer}>
                <Box sx={style.cancelButtonContainer}>
                    <ActionButton
                        label={'Cancel'}
                        action={handleClose}
                        buttonBordered
                        useBorderColor={'#07857C'}
                        withIcon={false}
                        sx={style.cancelButton}
                    />
                </Box>
                <Box>
                    <ActionButton
                        label={'Send'}
                        action={handleSubmit}
                        withIcon={false}
                        sx={style.sendButton} />
                </Box>
            </Box>
        </Fragment>
    )
}

const style = {
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '15px'
    },
    cancelButtonContainer: {
        width: '84px',
        marginRight: '15px'
    },
    cancelButton: {
        height: '35px',
    },
    sendButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
}